import { DeesElement, property, html, customElement, TemplateResult } from '@designestate/dees-element';
import * as domtools from '@designestate/dees-domtools';

import * as deesCatalog from '@designestate/dees-catalog';
deesCatalog;

@customElement('sio-subwidget-onboardme')
export class SioSubwidgetOnboardme extends DeesElement {
  @property()
  public showCombox = false;

  public static demo = () => html`
    <sio-subwidget-onboardme></sio-subwidget-onboardme>
  `;

  constructor() {
    super();
    domtools.DomTools.setupDomTools();
  }

  public render(): TemplateResult {
    return html`
      ${domtools.elementBasic.styles}
      <style>
        
        :host {
          display: block;
          position: relative;
          transition: all 0.1s;
          min-height: 200px;
          margin: 20px 20px 40px 20px;
          background: ${this.goBright ? '#fafafa' : '#2a2a2a'};
          border-radius: 3px;
          border-top: 1px solid rgba(250,250,250,0.2);
          box-shadow: 0px 0px 5px rgba(0,0,0,0.3);
          padding: 20px;
          color: #CCC;
        }

        :host(:hover) {
          border-top: 1px solid #e4002b;
        }

        .brandingbox {
          text-align: center;
          position: absolute;
          width: 100%;
          bottom: 0px;
          left: 0px;
          font-size: 10px;
          padding: 3px;
          border-top: 1px solid rgba(250,250,250, 0.05);
          font-family: Roboto Mono;
          background: ${this.goBright ? '#eee' : '#282828'};
          color: #666;
        }
      </style>
      Or search through our documentation
      <dees-form>
        <dees-input-text key="searchTerm" label="Search Term:"></dees-input-text>
      </dees-form>
      <div class="brandingbox">powered by onboard.me (by lossless.com)</div>
    `;
  }
}